// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N5UY","badges":"styles_badges__1WEmW"};